import axiosInstance from 'api/axiosInstance';
import { URL_CANTRACK_UPDATE_KEYWORD } from 'constants/urls';
import { KeywordUpdatePayload } from './types';

/**
 * Updates an existing keyword.
 * @param keywordData - The keyword fields to update (must include Id)
 * @returns The API response data
 * @throws Re-throws any Axios error after logging
 */
const updateKeyword = async (keywordData: KeywordUpdatePayload) => {
  try {
    const { data } = await axiosInstance({
      method: 'POST',
      url: URL_CANTRACK_UPDATE_KEYWORD,
      data: { payload: keywordData },
      headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    });
    return data;
  } catch (error) {
    console.error('[updateKeyword] Failed:', error);
    throw error;
  }
};

export default updateKeyword;
